module.exports = __webpack_public_path__ + "img/08_ic_plate_black_62px.f70b5a4b.svg";